import { ISelectOption } from "src/shared/types/field.types";
import { EOriginalAvailability } from "src/shared/types/partner.types";

export const originalAvailabilityOptions: Array<
  ISelectOption<EOriginalAvailability>
> = [
  {
    name: "Отсутствует",
    value: EOriginalAvailability.ABSENT,
  },
  {
    name: "В наличии",
    value: EOriginalAvailability.IN_STOCK,
  },
  {
    name: "Без документов",
    value: EOriginalAvailability.WIHOUT_DOCUMENTS,
  },
];
